import { Form, Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store/redux'
import Header from 'components/headers/bulletins'
import FormikInput from 'components/formikFields/input'
import Num2persian from 'utilities/helper/num2Persian'
import { useState } from 'react'
import classNames from 'classnames'
import FormikSelect from 'components/formikFields/select'
import { Schema, getMonthlyOptions, getWeeklyOptions } from './utils/indx'
import { toggleMemberShip } from 'store/redux/moneyPoolBox'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { toggleSupportModal } from 'store/redux/sidebar'
import SupportModal from 'components/modals/supportModal'
import { NumericFormat } from 'react-number-format'
import posthog from 'posthog-js'

export default function MemberShip() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [dueDate, setDueDate] = useState<string>(
        store?.dueDate ? store?.dueDate : 'monthly'
    )
    const { isOpenSupportModal } = useSelector(
        (state: RootState) => state.sideBarControler
    )

    return (
        <>
            <Formik
                initialValues={{
                    memberShipFee: store?.memberShipFee
                        ? store?.memberShipFee
                        : '',
                    date: store?.date ? store?.date : '',
                }}
                validationSchema={Schema}
                onSubmit={async (values) => {
                    if (Number(values.memberShipFee) < 5000) {
                        if (Number(values.memberShipFee) === 0) {
                            dispatch(
                                toggleMemberShip({
                                    memberShipFee: values.memberShipFee,
                                    date: values.date,
                                    dueDate,
                                })
                            )
                            navigate('/add-box/manage')
                        } else {
                            toast.error(
                                'حق عضویت نمی تواند کمتر از 5000 تومان باشد'
                            )
                        }
                    } else {
                        dispatch(
                            toggleMemberShip({
                                memberShipFee: values.memberShipFee,
                                date: values.date,
                                dueDate,
                            })
                        )
                        posthog.capture('fund_create_step_completed', {
                            step_name: 'membership',
                            step_index: 2,
                            membership_fee: values.memberShipFee,
                            is_transfer: !!store?.isTransfer,
                        })
                        navigate('/add-box/manage')
                    }
                }}
            >
                {({
                    submitForm,
                    values,
                    handleChange,
                    errors,
                    touched,
                    setFieldValue,
                }) => (
                    <Form>
                        <div className=" h-full flex flex-col bg-main-bg">
                            <div className=" grow-0">
                                <Header title="تنظیمات صندوق" />
                            </div>
                            <div className=" grow">
                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        حق عضویت صندوق
                                    </p>
                                    <div className=" mt-4">
                                        <p className=" text-sm my-2">
                                            {' '}
                                            حق عضویت
                                            <span className=" text-red-1 mx-2">
                                                (اجباری)
                                            </span>
                                        </p>
                                        <NumericFormat
                                            customInput={FormikInput}
                                            thousandSeparator
                                            placeholder="مبلغ(تومان)"
                                            allowNegative={false}
                                            name="amount"
                                            className="text-sm font-normal"
                                            isGray
                                            label=""
                                            defaultValue={values.memberShipFee}
                                            secondaryTitle="| تومان "
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue(
                                                    'memberShipFee',
                                                    value
                                                )
                                            }}
                                        />
                                        {errors.memberShipFee &&
                                            touched.memberShipFee && (
                                                <p className=" text-xs my-2 text-error-3 text-center">
                                                    {errors.memberShipFee}
                                                </p>
                                            )}

                                        <p className=" text-xs my-1 mx-2">
                                            مبلغی که عضو دارای سهم، تا هر سررسید
                                            صندوق پرداخت کرده و برای وی پس انداز
                                            می شود
                                        </p>
                                        {values.memberShipFee !== '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    Number(
                                                        values.memberShipFee
                                                    ).toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        سررسید صندوق
                                    </p>
                                    <div className="flex justify-center mx-4 my-4">
                                        <div className=" w-full bg-[#E6F3DD] rounded-full px-1 py-1 text-center flex justify-between">
                                            <p
                                                className={classNames(
                                                    ' w-full py-2 rounded-2xl transition ease-in-out delay-150 cursor-pointer',
                                                    dueDate === 'weekly'
                                                        ? ' bg-green-1 text-white'
                                                        : ' text-green-1'
                                                )}
                                                onClick={() =>
                                                    setDueDate('weekly')
                                                }
                                            >
                                                هفتگی
                                            </p>
                                            <p
                                                className={classNames(
                                                    ' w-full py-2 rounded-2xl transition ease-in-out delay-150 cursor-pointer',
                                                    dueDate === 'monthly'
                                                        ? ' bg-green-1 text-white'
                                                        : ' text-green-1'
                                                )}
                                                onClick={() =>
                                                    setDueDate('monthly')
                                                }
                                            >
                                                ماهانه
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <p className=" text-sm my-2">
                                            {' '}
                                            سررسید صندوق
                                            <span className=" text-red-1 mx-2">
                                                (اجباری)
                                            </span>
                                        </p>
                                        <FormikSelect
                                            name="date"
                                            label=""
                                            Options={
                                                dueDate === 'weekly'
                                                    ? getWeeklyOptions
                                                    : getMonthlyOptions()
                                            }
                                            firstOption="- - - - - - -"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className=" grow-0">
                                <div className=" text-center my-4">
                                    <p>نیاز به راهنمایی دارید؟</p>
                                    <p
                                        className=" text-[#808080] underline underline-offset-4"
                                        onClick={() =>
                                            dispatch(
                                                toggleSupportModal({
                                                    isOpenSupportModal: true,
                                                })
                                            )
                                        }
                                    >
                                        با مشاور همیان تماس بگیرید
                                    </p>
                                </div>
                                <div className=" bg-white py-4 px-4">
                                    <button className=" w-full bg-green-1 rounded-2xl text-white py-3">
                                        ادامه
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            <SupportModal
                show={isOpenSupportModal}
                onHide={() =>
                    dispatch(toggleSupportModal({ isOpenSupportModal: false }))
                }
            />
        </>
    )
}
